import { createApi } from "../axiosInstance";

const api = createApi("myBusiness");

// Fresh implementation, NOT the shared shareTransferApiFactory — mybusiness's ShareTransfer is
// fully local (own table `mybusiness_share_transfer`, own ShareTransferController), not proxied
// to fpo. Path prefix is /company/{companyId}/... (not /fpo/{fpoId}/...). The payload shape
// itself is identical to fpo's own ShareTransferCreatePayload (transferorMemberId,
// transferFolioNumber, distinctiveNumber, amountPaidUpOnShares, authorizedPerson, ...) — the
// existing ShareTransferPage.jsx already builds this exact shape before calling createShareTransfer,
// confirmed against both backends' payload classes.
export const getShareTransfer = (companyId) => api.get(`/company/${companyId}/transfer`);

export const createShareTransfer = (companyId, data) =>
  api.post(`/company/${companyId}/transfer`, data);

export const updateShareTransfer = (companyId, id, data) =>
  api.patch(`/company/${companyId}/transfer/${id}`, data);

export const getShareTransferById = (companyId, id) =>
  api.get(`/company/${companyId}/transfer/${id}`);

export const deleteShareTransferById = (companyId, id) =>
  api.delete(`/company/${companyId}/transfer/${id}`);

// Note: fpo's own ShareTransferController has no /member/{memberId}/transfer path either (it's
// /share/transfer?transferorId=&transfereeId=, same as mybusiness) — the shared factory's
// getShareTransferByMemberId(fpoId, memberId) calling /fpo/{fpoId}/member/{memberId}/transfer
// was already a pre-existing dead-code mismatch (confirmed unused anywhere in the UI). Matching
// the real backend shape here rather than perpetuating that.
export const getShareTransferByMemberId = (companyId, memberId) =>
  api.get(`/company/${companyId}/share/transfer`, { params: { transferorId: memberId } });

export const downloadShareTransfer = (companyId, params) =>
  api.get(`/company/${companyId}/transfer/download`, { params, responseType: "blob" });
